import React from "react";

const SelectRange = ({ options, label = "Select Unit", unit, setUnit, minValue, setMinValue, maxValue, setMaxValue }) => {
  // Handle unit change
  const handleUnitChange = (e) => {
    setUnit(e.target.value); // Set the selected unit
    const selectedOption = options.find(option => option.value === parseInt(e.target.value));

    // Reset min and max values when unit changes
    if (!selectedOption.hideMin) setMinValue(""); 
    if (!selectedOption.hideMax) setMaxValue("");
  };

  const handleMinChange = (e) => {
    setMinValue(e.target.value); // Update the min value
  };

  const handleMaxChange = (e) => {
    setMaxValue(e.target.value); // Update the max value
  };

  const selectedOption = options?.find(opt => opt.value === parseInt(unit)) || options[0];

  return (
    <div className="">
      {/* Select dropdown for duration units */}
      <div className="flex flex-col space-y-2">
        <label className="text-gray-700 font-medium">{ label }</label>
        <select
          value={unit || selectedOption?.value}  // Ensure the first option is selected by default
          onChange={handleUnitChange}
          className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Input fields for Min and Max values */}
      <div className={`flex ${!selectedOption.hideMin && !selectedOption.hideMax ? 'space-x-4' : ''}`}>
        {/* Min Input */}
        {!selectedOption.hideMin && (
          <div className={`flex-1 ${selectedOption.hideMax ? 'w-full' : 'w-1/2'}`}>
            <label className="text-gray-700 font-medium">Min Value</label>
            <input
              type="number"
              value={minValue}
              onChange={handleMinChange}
              placeholder="Enter min value"
              className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
            />
          </div>
        )}

        {/* Max Input */}
        {!selectedOption.hideMax ? (
          <div className={`flex-1 ${selectedOption.hideMin ? 'w-full' : 'w-1/2'}`}>
            <label className="text-gray-700 font-medium">Max Value</label>
            <input
              type="number"
              value={maxValue}
              onChange={handleMaxChange}
              placeholder="Enter max value"
              className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
            />
          </div>
        ) : null}
      </div>

    </div>
  );
};

export default SelectRange;
